/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-editor block)");
/* eslint-enable no-console */

(function () {
    const STORAGE_KEY = "sql_editor_db_v1";
    const HISTORY_MAX = 10;
    let db;
    let resultLimit = 100;
    let pendingImportSQL = null;
    let queryHistory = [];

    // ── Bandeau statut ──
    function setPersistStatus(msg, color = "#888") {
        const el = document.getElementById("persist-status");
        el.textContent = msg;
        el.style.color = color;
    }

    // ── Sauvegarder en localStorage ──
    function saveDB() {
        if (!db) return;
        try {
            const data = db.export();
            const b64 = btoa(String.fromCharCode(...data));
            localStorage.setItem(STORAGE_KEY, b64);
            const now = new Date().toLocaleTimeString("fr-FR");
            setPersistStatus(`💾 Base sauvegardée automatiquement à ${now}.`, "#2e7d32");
        } catch (e) {
            setPersistStatus("⚠ Impossible de sauvegarder en localStorage.", "#b71c1c");
        }
    }

    // ── Charger depuis localStorage ──
    function loadDBFromStorage(SQL) {
        const b64 = localStorage.getItem(STORAGE_KEY);
        if (!b64) return null;
        try {
            const binary = atob(b64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            return new SQL.Database(bytes);
        } catch (e) {
            return null;
        }
    }

    // ── Initialiser sql.js ──
    initSqlJs({ locateFile: file => `https://cdn.jsdelivr.net/npm/sql.js/dist/${file}` })
        .then(SQL => {
            window.SQL = SQL;
            const restored = loadDBFromStorage(SQL);
            if (restored) {
                db = restored;
                setPersistStatus("✅ Base restaurée depuis la session précédente.", "#1565c0");
                showAllTablesAndData();
            } else {
                resetDB();
            }
        })
        .catch(err => {
            document.getElementById("results").innerHTML =
                `<p style="color:red;"><strong>Erreur sql.js :</strong> ${err}</p>`;
        });

    // ── CodeMirror ──
    const editor = CodeMirror.fromTextArea(
        document.getElementById("sql-editor-input"), {
        mode: "text/x-sql",
        lineNumbers: true,
        theme: "default",
        autofocus: true,
        lineWrapping: false,
        extraKeys: {
            "Ctrl-Enter": executeSQL,
            "Cmd-Enter": executeSQL
        }
    }
    );

    // ── Événements boutons ──
    document.getElementById("sql-button-execute").addEventListener("click", executeSQL);
    document.getElementById("sql-button-reset").addEventListener("click", resetDB);
    document.getElementById("sql-button-clear").addEventListener("click", () => {
        editor.setValue("");
        editor.focus();
    });
    document.getElementById("sql-button-schema").addEventListener("click", () => {
        document.getElementById("results").innerHTML = "";
        showSchemaSection();
    });
    document.getElementById("sql-result-limit").addEventListener("change", function () {
        resultLimit = parseInt(this.value, 10);
    });
    document.getElementById("sql-button-export").addEventListener("click", exportDumpSQL);
    document.getElementById("sql-file-import").addEventListener("change", handleFileSelected);

    document.getElementById("sql-examples").addEventListener("change", function () {
        if (!this.value) return;
        editor.setValue(this.value);
        editor.focus();
        this.selectedIndex = 0;
    });

    document.getElementById("sql-history").addEventListener("change", function () {
        if (!this.value) return;
        editor.setValue(this.value);
        editor.focus();
        this.selectedIndex = 0;
    });

    // ── Modal import ──
    document.getElementById("modal-btn-cancel").addEventListener("click", () => {
        document.getElementById("sql-import-modal").classList.remove("active");
        pendingImportSQL = null;
    });
    document.getElementById("modal-btn-confirm").addEventListener("click", () => {
        document.getElementById("sql-import-modal").classList.remove("active");
        if (pendingImportSQL) {
            applyImport(pendingImportSQL);
            pendingImportSQL = null;
        }
    });

    // ── Historique ──
    function addToHistory(sql) {
        const trimmed = sql.trim();
        if (!trimmed) return;
        if (queryHistory[0] === trimmed) return;
        queryHistory.unshift(trimmed);
        if (queryHistory.length > HISTORY_MAX) queryHistory.pop();

        const select = document.getElementById("sql-history");
        select.innerHTML = '<option value="">— Historique —</option>';
        queryHistory.forEach((q, i) => {
            const opt = document.createElement("option");
            opt.value = q;
            opt.textContent = `${i + 1}. ${q.length > 50 ? q.slice(0, 50) + "…" : q}`;
            select.appendChild(opt);
        });
    }

    // ── Exécuter SQL ──
    function executeSQL() {
        const sql = editor.getValue();
        const resultsDiv = document.getElementById("results");
        resultsDiv.innerHTML = "";

        if (!db) {
            resultsDiv.innerHTML = "<p style='color:red;'>Base non encore chargée.</p>";
            return;
        }

        addToHistory(sql);

        try {
            const results = db.exec(sql);

            if (results.length > 0 && results[0].values.length > 0) {
                const resultQueryDiv = document.createElement("div");
                resultQueryDiv.id = "result-query";
                resultQueryDiv.innerHTML = "<strong>Résultat de la requête</strong>";

                const table = document.createElement("table");
                const header = table.insertRow();
                results[0].columns.forEach(col => {
                    const th = document.createElement("th");
                    th.textContent = col;
                    header.appendChild(th);
                });

                const displayedRows = results[0].values.slice(0, resultLimit);
                displayedRows.forEach(row => {
                    const tr = table.insertRow();
                    row.forEach(cell => {
                        tr.insertCell().textContent = cell ?? "";
                    });
                });

                resultQueryDiv.appendChild(table);
                resultsDiv.appendChild(resultQueryDiv);

                if (results[0].values.length > displayedRows.length) {
                    const p = document.createElement("p");
                    p.style.color = "#666";
                    p.textContent = `(Affichage limité à ${resultLimit} lignes sur ${results[0].values.length})`;
                    resultsDiv.appendChild(p);
                }
            } else {
                // Lignes affectées pour INSERT / UPDATE / DELETE
                const affected = db.getRowsModified();
                const span = document.createElement("span");
                span.textContent = affected > 0
                    ? `Requête exécutée — ${affected} ligne(s) affectée(s).`
                    : "Requête exécutée (aucun résultat à afficher).";
                resultsDiv.appendChild(span);
            }

            const sqlUpper = sql.trim().toUpperCase();
            const pedagogicMap = [
                [/^CREATE TABLE/, "<p><em>✅ Une nouvelle table a été créée.</em></p>"],
                [/^INSERT INTO/, "<p><em>✅ Des enregistrements ont été ajoutés.</em></p>"],
                [/^UPDATE/, "<p><em>✅ Des enregistrements ont été modifiés.</em></p>"],
                [/^DELETE FROM/, "<p><em>✅ Des enregistrements ont été supprimés.</em></p>"],
                [/^DROP TABLE/, "<p><em>🗑 Une table a été supprimée.</em></p>"],
                [/^ALTER TABLE/, "<p><em>🔧 La structure de la table a été modifiée.</em></p>"],
            ];
            for (const [pattern, msg] of pedagogicMap) {
                if (pattern.test(sqlUpper)) {
                    resultsDiv.insertAdjacentHTML("afterbegin", msg);
                    break;
                }
            }

            showAllTablesAndData();
            saveDB();

        } catch (e) {
            const p = document.createElement("p");
            p.style.color = "red";
            p.textContent = `Erreur SQL : ${e.message}`;
            resultsDiv.appendChild(p);
        }
    }

    // ── Afficher tables + données ──
    function showAllTablesAndData() {
        const resultsDiv = document.getElementById("results");
        const tablesSection = document.createElement("div");
        tablesSection.id = "tables-section";
        tablesSection.innerHTML = "<strong>Tables et données actuelles</strong>";

        try {
            const tablesResults = db.exec(
                `SELECT name FROM sqlite_schema WHERE type='table' AND name NOT LIKE 'sqlite_%';`
            );

            if (!tablesResults.length || !tablesResults[0].values.length) {
                tablesSection.innerHTML += "<p>Aucune table trouvée.</p>";
            } else {
                tablesResults[0].values.forEach(([tableName]) => {
                    const h3 = document.createElement("h3");
                    h3.textContent = `Table : ${tableName}`;
                    tablesSection.appendChild(h3);

                    const dataResults = db.exec(`SELECT * FROM "${tableName}";`);
                    if (!dataResults.length || !dataResults[0].values.length) {
                        tablesSection.appendChild(document.createTextNode(" (vide)"));
                        return;
                    }

                    const table = document.createElement("table");
                    const header = table.insertRow();
                    dataResults[0].columns.forEach(col => {
                        const th = document.createElement("th");
                        th.textContent = col;
                        header.appendChild(th);
                    });
                    dataResults[0].values.forEach(row => {
                        const tr = table.insertRow();
                        row.forEach(cell => {
                            tr.insertCell().textContent = cell ?? "";
                        });
                    });
                    tablesSection.appendChild(table);
                });
            }
            resultsDiv.appendChild(tablesSection);
        } catch (e) {
            tablesSection.innerHTML += `<p style="color:red;">Erreur : ${e.message}</p>`;
            resultsDiv.appendChild(tablesSection);
        }
    }

    // ── Schéma des tables ──
    function showSchemaSection() {
        const resultsDiv = document.getElementById("results");
        const schemaSection = document.createElement("div");
        schemaSection.id = "sql-schema-section";
        schemaSection.innerHTML = "<strong>Schéma des tables</strong>";

        try {
            const schemaResults = db.exec(
                `SELECT name, sql FROM sqlite_schema WHERE type='table' AND name NOT LIKE 'sqlite_%';`
            );

            if (!schemaResults.length || !schemaResults[0].values.length) {
                schemaSection.innerHTML += "<p>Aucune table trouvée.</p>";
            } else {
                const table = document.createElement("table");
                const header = table.insertRow();
                ["Table", "Définition (CREATE TABLE)"].forEach(txt => {
                    header.insertCell().innerHTML = `<strong>${txt}</strong>`;
                });
                schemaResults[0].values.forEach(([name, sql]) => {
                    const tr = table.insertRow();
                    tr.insertCell().textContent = name;
                    const td = tr.insertCell();
                    const code = document.createElement("code");
                    code.textContent = sql;
                    td.appendChild(code);
                });
                schemaSection.appendChild(table);
            }
            resultsDiv.appendChild(schemaSection);
        } catch (e) {
            schemaSection.innerHTML += `<p style="color:red;">Erreur schéma : ${e.message}</p>`;
            resultsDiv.appendChild(schemaSection);
        }
    }

    // ── Reset base ──
    function resetDB() {
        if (!window.SQL) {
            document.getElementById("results").innerHTML =
                "<p style='color:red;'>Erreur : SQL non chargé.</p>";
            return;
        }
        db = new window.SQL.Database();
        db.exec("CREATE TABLE IF NOT EXISTS users (id INTEGER PRIMARY KEY, name TEXT);");
        db.exec("INSERT INTO users (name) VALUES ('Alice'), ('Bob');");
        localStorage.removeItem(STORAGE_KEY);
        setPersistStatus("🔄 Base réinitialisée (localStorage effacé).", "#e65100");
        document.getElementById("results").innerHTML =
            "<em>Base réinitialisée. Table 'users' créée avec deux enregistrements.</em>";
        showAllTablesAndData();
        saveDB();
    }

    // ── Export dump SQL ──
    function exportDumpSQL() {
        if (!db) { alert("Base non disponible."); return; }

        let output = "-- Export SQL généré le " + new Date().toLocaleString("fr-FR") + "\n\n";

        try {
            const tablesResults = db.exec(
                `SELECT name, sql FROM sqlite_schema
                     WHERE type='table' AND name NOT LIKE 'sqlite_%';`
            );

            if (!tablesResults.length || !tablesResults[0].values.length) {
                alert("Aucune table à exporter.");
                return;
            }

            tablesResults[0].values.forEach(([tableName, createSQL]) => {
                output += `-- Table : ${tableName}\n`;
                output += `DROP TABLE IF EXISTS "${tableName}";\n`;
                output += createSQL + ";\n\n";

                const dataResults = db.exec(`SELECT * FROM "${tableName}";`);
                if (dataResults.length && dataResults[0].values.length) {
                    const columns = dataResults[0].columns.map(c => `"${c}"`).join(", ");
                    dataResults[0].values.forEach(row => {
                        const values = row.map(cell => {
                            if (cell === null) return "NULL";
                            if (typeof cell === "number") return cell;
                            return `'${String(cell).replace(/'/g, "''")}'`;
                        }).join(", ");
                        output += `INSERT INTO "${tableName}" (${columns}) VALUES (${values});\n`;
                    });
                    output += "\n";
                } else {
                    output += `-- (table vide)\n\n`;
                }
            });

            const blob = new Blob([output], { type: "text/plain;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "export_base.sql";
            a.click();
            URL.revokeObjectURL(url);

        } catch (e) {
            alert("Erreur export : " + e.message);
        }
    }

    // ── Étape 1 : fichier sélectionné → modal ──
    function handleFileSelected(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = function (e) {
            pendingImportSQL = e.target.result;
            const stmtCount = (pendingImportSQL.match(/;/g) || []).length;
            document.getElementById("modal-message").innerHTML =
                `Fichier sélectionné : <code>${file.name}</code><br>
                     (~${stmtCount} instruction(s) détectée(s))`;
            document.getElementById("sql-import-modal").classList.add("active");
        };
        reader.onerror = () => setPersistStatus("⚠ Erreur de lecture du fichier.", "#b71c1c");
        reader.readAsText(file, "UTF-8");
        event.target.value = "";
    }

    // ── Étape 2 : après confirmation → Reset + exécuter ──
    function applyImport(sqlContent) {
        if (!window.SQL) {
            setPersistStatus("⚠ SQL non chargé.", "#b71c1c");
            return;
        }

        db = new window.SQL.Database();
        localStorage.removeItem(STORAGE_KEY);

        const resultsDiv = document.getElementById("results");
        resultsDiv.innerHTML = "";

        try {
            db.exec(sqlContent);
            setPersistStatus("✅ Import réussi — base reconstruite depuis le fichier.", "#2e7d32");
            resultsDiv.innerHTML = "<em>✅ Import réussi. Base reconstruite depuis le fichier importé.</em>";
            showAllTablesAndData();
            saveDB();
        } catch (e) {
            setPersistStatus("⚠ Erreur lors de l'import.", "#b71c1c");
            resultsDiv.innerHTML = `<p style="color:red;">Erreur à l'import : ${e.message}</p>`;
            saveDB();
        }
    }
})()
